import { render, staticRenderFns } from "./ProjectForumTopicSkeleton.vue?vue&type=template&id=2daf993e&scoped=true"
import script from "./ProjectForumTopicSkeleton.vue?vue&type=script&lang=ts"
export * from "./ProjectForumTopicSkeleton.vue?vue&type=script&lang=ts"
import style0 from "./ProjectForumTopicSkeleton.vue?vue&type=style&index=0&id=2daf993e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daf993e",
  null
  
)

export default component.exports